<template>
  <div v-if="isReady">
    <table>
      <tr>
        <td>
          <img @click="clickKey('1')" src="/imgs/key_1_1.png">
        </td>
        <td>
          <img @click="clickKey('2')" src="/imgs/key_2_1.png">
        </td>
        <td>
          <img @click="clickKey('3')" src="/imgs/key_3_1.png">
        </td>
      </tr>
      <tr>
        <td>
          <img @click="clickKey('4')" src="/imgs/key_4_1.png">
        </td>
        <td>
          <img @click="clickKey('5')" src="/imgs/key_5_1.png">
        </td>
        <td>
          <img @click="clickKey('6')" src="/imgs/key_6_1.png">
        </td>
      </tr>
      <tr>
        <td>
          <img @click="clickKey('7')" src="/imgs/key_7_1.png">
        </td>
        <td>
          <img @click="clickKey('8')" src="/imgs/key_8_1.png">
        </td>
        <td>
          <img @click="clickKey('9')" src="/imgs/key_9_1.png">
        </td>
      </tr>
      <tr v-if="isSum">
        <td>
          <img @click="clickKey('.')" src="/imgs/key_dot_1.png">
        </td>
        <td colspan="2">
          <img @click="clickKey('0')" src="/imgs/key_0dot_1.png">
        </td>
      </tr>
      <tr v-else>
        <td colspan="3">
          <img @click="clickKey('0')" src="/imgs/key_0_1.png">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  name: 'KeyboardDigital',
  props: {
    'onClick': {
      type: Function,
      default: null
    },
    'isSum': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isReady: false
    }
  },
  mounted() {
    this.isReady = true;
  },
  methods: {
    clickKey(key) {
      this.onClick(key);
    },
  }
}
</script>

<style scoped>

</style>
